"use client";

import { useEffect } from "react";
import { AppRootLayout } from "@/src/components/layouts";
import { GlobalErrorPage } from "@/src/components/pages";
import { FC } from "react";
import { logError } from "@/src/api/server-actions/analytics";

interface GlobalErrorProps {
    error: Error & { digest?: string };
    reset: () => void;
}

const GlobalError: FC<GlobalErrorProps> = ({ error }) => {
    useEffect(() => {
        logError(`[global-error.tsx] Unhandled error [digest=${error?.digest}]`, error);
    }, [error]);

    return (
        <AppRootLayout>
            <GlobalErrorPage
                title={"Скоро повернемось!"}
                description={
                    "Ми працюємо над тим, щоб якнайшвидше відновити роботу сайту. Поверніться пізніше — ми вас чекатимемо!"
                }
                image={{
                    src: "/images/global-error.png",
                    alt: "Global error image",
                    width: 200,
                    height: 205,
                }}
            />
        </AppRootLayout>
    );
};

export default GlobalError;
